import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import Assessments from "@/pages/Assessments";
import AssessmentWorkspace from "@/pages/AssessmentWorkspace";
import FrameworkLibrary from "@/pages/FrameworkLibrary";
import ComplianceMatrix from "@/pages/ComplianceMatrix";
import Evidence from "@/pages/Evidence";
import Integrations from "@/pages/Integrations";
import Reports from "@/pages/Reports";
import Remediation from "@/pages/Remediation";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";

function Page({ children, roles }) {
  return (
    <ProtectedRoute roles={roles}>
      <AppShell>{children}</AppShell>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Page><Dashboard /></Page>} />
          <Route path="/clients" element={<Page><Clients /></Page>} />
          <Route path="/assessments" element={<Page><Assessments /></Page>} />
          <Route path="/assessments/:id" element={<Page><AssessmentWorkspace /></Page>} />
          <Route path="/framework" element={<Page><FrameworkLibrary /></Page>} />
          <Route path="/compliance-matrix" element={<Page><ComplianceMatrix /></Page>} />
          <Route path="/evidence" element={<Page><Evidence /></Page>} />
          <Route path="/integrations" element={<Page roles={["super_admin", "assessor"]}><Integrations /></Page>} />
          <Route path="/reports" element={<Page><Reports /></Page>} />
          <Route path="/remediation" element={<Page><Remediation /></Page>} />
          <Route path="/users" element={<Page roles={["super_admin"]}><Users /></Page>} />
          <Route path="/settings" element={<Page roles={["super_admin"]}><Settings /></Page>} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
